import React from 'react';
import './Message.css';
import { format, subMinutes } from 'date-fns';
import logComponent from '../../common/logComponent';

export default function Message({ thread, message, own, showTimeAndSender }) {

  if (logComponent('Message')) { console.debug('Message rendered'); }

  const getTimeZoneAdjustedTime = () => {
    if (logComponent('Message')) { console.debug('Message getTimeZoneAdjustedTime'); }

    const date = new Date(message.sentOn);
    const tzOffset = date.getTimezoneOffset();
    const tzAdjustedDate = subMinutes(date, tzOffset);

    return format(tzAdjustedDate, 'MMMM d, yyyy h:mm aaa');
  }


  return (
    <div className={'Message' + (own ? ' Message--own' : ' Message--other')}>
      <p className={'Message__text' + (own ? ' Message__text--own' : thread.IsPrivate ? ' Message__text--direct' : ' Message__text--family')}>
        {message.message}
      </p>
      {
        showTimeAndSender &&
        <React.Fragment>
          <p className="Message__sender">
            {message.createdByUser.facilityId ? `${message.createdByUser.legalFirstName} ${message.createdByUser.lastName.substring(0, 1)}.` : message.createdByUser.displayName}
          </p>
          <p className="Message__time">
            {getTimeZoneAdjustedTime()}
          </p>
        </React.Fragment>
      }
    </div>
  );
}